import { FontColorEnum, FormField, FormHint } from '@acceso/design-system';
import { Controller, FieldValues, Path, PathValue, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ReviewStateEnum } from '@/features/segments/types';

import { StatusSeenChipSelect } from '../StatusSeenChipSelect';

type TInputStatusSeenChipSelectProps<T extends FieldValues> = {
  form: UseFormReturn<T>;
  name: Path<T>;
  required?: boolean;
  disabled?: boolean;
};

export function InputStatusSeenChipSelect<T extends FieldValues>({
  form,
  name,
  required,
  disabled,
}: TInputStatusSeenChipSelectProps<T>) {
  const { t } = useTranslation();
  const { control } = form;

  return (
    <FormField>
      <Controller
        disabled={disabled}
        name={name}
        control={control}
        rules={{
          required: required ? { value: true, message: t('El campo es obligatorio') } : false,
        }}
        defaultValue={ReviewStateEnum.REQUIRE_REVIEW as PathValue<T, Path<T>>}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <div className="flex w-full justify-end">
            <StatusSeenChipSelect value={value} onChange={value => onChange(Number(value))} />

            {error && (
              <FormHint color={FontColorEnum.Error20} type="error">
                {error.message}
              </FormHint>
            )}
          </div>
        )}
      />
    </FormField>
  );
}
